/* unplugin-vue-components disabled */import { ElIcon as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_1 from '~icons/custom/question';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f7c5857"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "channel-conf"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("回收站");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加渠道");
import { useAppStore } from '@/store/modules/app';
import ChannelList from './modules/channelList.vue';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const ChannelConf = defineAsyncComponent(() => import('./channelConf.vue'));
    const AddChannel = defineAsyncComponent(() => import('./modules/addChannel/index.vue'));
    const PlugConfig = defineAsyncComponent(() => import('./modules/plugConfig.vue'));
    const gameInfo = computed(() => useAppStore().gameInfo);
    const activePane = ref('channelList');
    const currentChannel = ref({});
    const panes = computed(() => {
      return [{
        title: '渠道列表',
        key: 'channelList'
      }, {
        title: '回收站',
        key: 'recycleBin'
      }, {
        title: `渠道配置(${currentChannel.value.name})`,
        key: 'channelConf'
      }, {
        title: `插件配置(${currentChannel.value.name})`,
        key: 'pluginConf',
        class: 'plugin-style'
      }, {
        title: '添加渠道',
        key: 'addChannel'
      }];
    });
    watch(() => gameInfo.value.Id, val => {
      if (val) {
        activePane.value = 'channelList';
      }
    }, {
      immediate: true
    });
    // 更改渠道状态
    const handleChangeActive = () => {
      activePane.value = 'recycleBin';
    };
    const handleCurrentChannel = row => {
      currentChannel.value = row;
    };
    const handleActive = type => {
      activePane.value = type;
    };
    const dictChannel = ref(['uc', 'ysdk', 'mi', 'oppo', 'vivo', 'huawei', 'meizu', 'baidu']);
    // 跳转到文档
    const handleToUrl = () => {
      const dict = {
        uc: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-JttpdT5yToDkodxIDKwcBC5Bneg',
        ysdk: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-YbMwdL7jkopqhexJlDPcd8qqnoc',
        mi: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-Ob46dr6XAo6xh0xV997cDaAknQd',
        oppo: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-EpyPdhtQgo6ML5xDtE6cRkZYnGc',
        vivo: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-EmamddqUPo0ellxhfgEcEXQEnbq',
        huawei: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-FEmjd8E3bo0X8bxuBdgcjAzvnLx',
        meizu: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-SoWGdlMzGoCphIxOVPHcO8wnngg',
        baidu: 'https://herogames.feishu.cn/wiki/wikcnf0YTyc9VTd5t3fR2akNuGc#part-LCuNdBs14oaxovxEBppcqzTLnAB'
      };
      const {
        channel
      } = currentChannel.value;
      window.open(dict[channel]);
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_i_custom_question = __unplugin_components_1;
      const _component_el_icon = __unplugin_components_2;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_u_card, {
        modelValue: activePane.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => activePane.value = $event),
        panes: _unref(panes)
      }, _createSlots({
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "channelList"
        }, {
          default: _withCtx(() => [_createVNode(ChannelList, {
            ref: "channelList",
            gameInfo: _unref(gameInfo),
            activePane: activePane.value,
            onOnActive: handleActive,
            onOnCurrentChannel: handleCurrentChannel
          }, null, 8, ["gameInfo", "activePane"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "recycleBin"
        }, {
          default: _withCtx(() => [_createVNode(ChannelList, {
            ref: "recycleBin",
            gameInfo: _unref(gameInfo),
            activePane: activePane.value
          }, null, 8, ["gameInfo", "activePane"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "channelConf"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ChannelConf), {
            gid: _unref(gameInfo).Id,
            channel: currentChannel.value
          }, null, 8, ["gid", "channel"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "addChannel"
        }, {
          default: _withCtx(() => [_createVNode(_unref(AddChannel), {
            gid: _unref(gameInfo).Id
          }, null, 8, ["gid"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "pluginConf"
        }, {
          default: _withCtx(() => [_createVNode(_unref(PlugConfig), {
            gid: _unref(gameInfo).Id,
            channel: currentChannel.value,
            activeName: activePane.value
          }, null, 8, ["gid", "channel", "activeName"])]),
          _: 1
        })]),
        _: 2
      }, [activePane.value === 'channelList' ? {
        name: "extra",
        fn: _withCtx(() => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: handleChangeActive
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => handleActive('addChannel'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })])
      } : undefined, activePane.value === 'channelConf' && dictChannel.value.includes(currentChannel.value.channel) ? {
        name: "left-extra",
        fn: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "cp",
          size: 20,
          onClick: handleToUrl
        }, {
          default: _withCtx(() => [_createVNode(_component_i_custom_question)]),
          _: 1
        })])
      } : undefined]), 1032, ["modelValue", "panes"])]);
    };
  }
});